export enum TokenType {
    candidateEmailVerification = 'candidateEmailVerification',
    employerEmailVerification = 'employerEmailVerification',
    joinEmployerEmailVerification = 'joinEmployerEmailVerification',
}
